import { Component, OnInit, ViewChild, HostListener, ViewEncapsulation, ElementRef } from '@angular/core';
import { DigitaltwinFetchService } from './digitaltwin-fetch.service';
import { ActivatedRoute, Router } from "@angular/router";
import * as THREE from 'three';
import { OrbitControls } from '@avatsaev/three-orbitcontrols-ts';

import { TransformControls } from 'three/examples/jsm/controls/TransformControls';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { MatSnackBar } from '@angular/material/snack-bar';
//import { PCDLoader } from 'three/examples/jsm/loaders/PCDLoader';

import { EditComponent } from './../edit/edit.component'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ShelterModalComponent } from './shelter-modal/shelter-modal.component';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-digitaltwin',
  templateUrl: './digitaltwin.component.html',
  styleUrls: ['./digitaltwin.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class DigitaltwinComponent implements OnInit {
  year;
  Link;
  urlSafe;
  displayedColumns = ["Name", "NameEdit", "Value", "ValueEdit", "Image", "ImageEdit"];
  displayedColumnsUser =  ["Name", "Value", "Image"];
  selectedFeature = 1;
  selectedShelter = null;
  selectedEquipment = null;
  renderer;
  scene;
  loaded = false;
  camera;
  role;
  controls;
  siteData;
  auditData;
  outDoorEquipments = [];
  cadData = [];
  cameraData;
  pointCloudData;
  assetDataIndex;
  leg;
  tower;
  siteId;
  imageUpdateArray = [];
  updatedValue = '';
  updatedOption;
  towers = [];
  telcoObjGrp;
  pointsCloud;
  transformControl;
  box;
  assetData;
  dragControls;
  isOpen = false;
  assets = [];
  reqAnimGlobalId = 0;
  stepsAbc = 0;
  initialPosAbc;
  finalPosAbc;
  lookAtObjAbc;
  newPositionAbc;
  addEquipment = '';
  detailImageIndex = 0;
  sliderValue = 0;
  mouse = new THREE.Vector2();
  crntImg = 0;
  raycaster = new THREE.Raycaster();
  controllerMode = 'Rotate';
  rotExtraAngle = 0.1;
  panHoriDelta = 12;
  prevObj = null;
  prevObjArr = []
  @ViewChild("container") container;
  isLoaded = true;
  abc = null;
  gizmoControl; gizmoClicked = false; antennaClicked = 0;
  linePts = []; objects = []; sphere;
  editMode = 'Add';
  summary_page_connections;
  sumArray = [];
  dtLoaded = 'loader';
  prg = '';
  compass_arrow: ElementRef;
  cameraViewVector = new THREE.Vector3();
  compassTarget = new THREE.Vector3( 0, 0, - 1 );
  compassAngleFromNorth = 0
  isArrowInitiated = false;
  isLowValid;
  isHighValid;
  Isdigi = true;
  IsDigiError = ""
  glbLoaderPrg = '';
  glbLoaderPrgHigh = 'dn';
  percentageLoaded = {
    prtLd : '0.00',
    prtLdHigh: '0.00'
  };
  abortLowScene;
  abortHighScene;
  allLoaded = false;
  animationID;

  constructor(private router: Router, private snackBar: MatSnackBar, private dialog: MatDialog, private service: DigitaltwinFetchService, private route: ActivatedRoute, public sanitizer: DomSanitizer) {

    if (this.router.url.split('/')[1] == "aero-processing") {
      this.role = "aero-processing";
    }
    if (this.router.url.split('/')[1] == "user") {
      this.role = 'user';
    }
    if (this.router.url.split('/')[1] == "pilot") {
      this.role = 'pilot';
    }
    if (this.router.url.split('/')[1] == "super-admin") {
      this.role = 'super-admin';
    }
    if (this.router.url.split('/')[1] == "telstra-processing") {
      this.role = 'telstra-processing';
    }

    this.route.params.subscribe(query => {            
      let tw = query.tower.split('___');      
      this.tower = tw[0]
      this.siteId= tw[1];
      this.year = query.year;
      if (this.tower == 'ESPERANCERT') {
        this.linePts.push({ "x1": 1.167579319660474, "y1": 28.67686424450075, "z1": 1.1512776277898586, "x2": 1.3819896058106078, "y2": 15.469401179448381, "z2": 1.5101677585009305 });
        this.linePts.push({ "x1": -1.1388925499598077, "y1": 28.753859720203486, "z1": 1.1171983778938959, "x2": -1.4614762551768727, "y2": 15.469401179448381, "z2": 1.3836076765142185 });
        this.linePts.push({ "x1": -1.1388925499598077, "y1": 28.753859720203486, "z1": -1.2337058013349882, "x2": -1.4614762551768727, "y2": 15.469401179448381, "z2": -1.5095117201002637 });
        this.linePts.push({ "x1": 1.1813431261414022, "y1": 28.67686424450075, "z1": -1.2556783919788286, "x2": 1.3819896058106078, "y2": 15.469401179448381, "z2": -1.5095117201002637 });

        this.linePts.push({ "x1": 1.3819896058106078, "y1": 15.469401179448381, "z1": 1.5101677585009305, "x2": 5.277883966756319, "y2": -40.20255394338287, "z2": 5.510888003045423 });
        this.linePts.push({ "x1": -1.4614762551768727, "y1": 15.469401179448381, "z1": 1.3836076765142185, "x2": -5.46967862992345, "y2": -40.10200028236667, "z2": 5.36465555507443 });
        this.linePts.push({ "x1": -1.4614762551768727, "y1": 15.469401179448381, "z1": -1.5095117201002637, "x2": -5.46967862992345, "y2": -40.10200028236667, "z2": -5.288295338630794 });
        this.linePts.push({ "x1": 1.3819896058106078, "y1": 15.469401179448381, "z1": -1.5095117201002637, "x2": 5.2740565617943265, "y2": -40.10200028236667, "z2": -5.227822538192429 });
      }
    })
    this.service.setData(this.tower,this.siteId,this.year).get().subscribe(
      (response) => {
        let data = response.data();
        this.Link = data['DigitalTwin']['Link'];
        if (this.Link && this.Link != "") {
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.Link);
        } else {
          this.Link = null;
          this.siteData = data['Audit']['General'];
          console.log(this.siteData[0]);
          if(data['DigitalTwin'].hasOwnProperty("CAD")){
            this.auditData = data['Audit'];
            this.outDoorEquipments = data['DigitalTwin']['OutDoorEquipment'];
            this.cadData = data['DigitalTwin']['CAD'];
            this.isLowValid = this.cadData.hasOwnProperty("Link_low") ? this.cadData['Link_low'] != "" : false
            this.isHighValid = this.cadData.hasOwnProperty("Link") ? this.cadData['Link'] != "" : false
            if(this.isHighValid){
              this.cameraData = data['DigitalTwin']['Camera'];
              this.main();
            }
            else{
              this.container.nativeElement.setAttribute('style', 'display: none');
              this.Isdigi = false
              this.IsDigiError = "Digitwin Not Available"
            }
          }
          else{
            this.container.nativeElement.setAttribute('style', 'display: none');
            this.Isdigi = false
            this.IsDigiError = "Digitwin Not Available"
          }
        }
      },
      (err) => {
        this.snackBar.open(err, "close", { duration: 2000 });
      },
      () => {
      }
    )

  }

  ngOnInit(): void {
    this.service.fetchProjectSetting().valueChanges().subscribe(items=> {
      
      this.summary_page_connections = items['summary_page_connections']
      console.log(this.summary_page_connections);
      this.summaryArray()
    })
  }

  summaryArray(){
    console.log(Number(this.summary_page_connections[0]));
    for (let i = 0; i < this.summary_page_connections.length; i++) {
      let d = this.summary_page_connections[i].split(",");
      for (let i = 0; i < d.length; i++) {
        d[i] = (Number(d[i]) - 1)       
      }
      this.sumArray.push(d)  
    }
  }

  nextImg() {
    if (this.crntImg != this.assetData.Details[this.detailImageIndex].Image.length - 1) {
      this.crntImg++;
    } else {
      this.crntImg = 0;
    }
  };

  prevImg() {
    if (this.crntImg != 0) {
      this.crntImg--;
    } else {
      this.crntImg = this.assetData.Details[this.detailImageIndex].Image.length - 1;
    }
  }


  animate() {
    this.renderer.render(this.scene, this.camera);
    this.animationID = window.requestAnimationFrame((id) => this.animate());
  }


  toggleEquipments(name, index = null) {
    this.clearSelection();
    this.detailImageIndex = 0;
    this.isOpen = false;
    this.crntImg = 0;
    this.selectedFeature = 3;
    this.selectedEquipment = index;
    if(this.allLoaded == true && this.glbLoaderPrgHigh == 'dn'){
    this.selectAsset(name);
    }
    this.assetDetails(name, index)
    this.isOpen = true;
  }

  assetDetails(elt, index) {
    for (let i = 0; i < this.auditData.Equipment.length; i++) {
      if (this.auditData.Equipment[i].Name == elt) {
        this.assetDataIndex = i;
        this.assetData = this.auditData.Equipment[i];
      }
    }
    //  this.assetDataIndex = index;
    //  this.assetData = this.auditData.Equipment[index];
  }

  selectAsset(elt) {
    console.log('elt - ', elt)
    if (this.box) {
      this.scene.remove(this.box);
    }
    let objNow = this.scene.getObjectByName(elt);
    this.box = new THREE.BoxHelper(objNow, "yellow"); //0xffff00 //rgb(17, 171, 198)
    this.box.geometry.computeBoundingBox();
    this.scene.add(this.box);

    if(objNow != undefined){
      objNow.traverse((child) => {
        // if (child instanceof THREE.Mesh) {
        // 'antenna____base' ????? && (child.name === 'antenna')
        // console.log('selected child - ', child);
        
        // if ((child.type== "Mesh") && ((this.tower == 'ESPERANCERT') || (this.tower == 'ALBANYEXCHANGE'))){
  
        //   this.prevObj = child;
        //   this.prevMatr = child.material.color.r;
        //   this.prevMatg = child.material.color.g;
        //   this.prevMatb = child.material.color.b;
        //   // console.log('this.prevMat- ', child);
        //   // console.log('this.prevMat- ', this.prevObj);
        //   child.material.color.r = 1;
        //   child.material.color.g = 0.1;
        //   child.material.color.b = 0.1;
  
        // }
        // else 
        if ((child.type== "Mesh") && (this.tower != 'ESPERANCERT') && (this.tower != 'ALBANYEXCHANGE') && (this.tower != 'CLARENDONCMTS') && (this.tower != 'ALTONAINDUSTRIAL') && (this.tower != 'ALSTONVILLEEXCHANGE')){
  
          // this.prevObj = child;
          // this.prevMatr = child.material.color.r;
          // this.prevMatg = child.material.color.g;
          // this.prevMatb = child.material.color.b;
          // // console.log('this.prevMat- ', child);
          // // console.log('this.prevMat- ', this.prevObj);
          // child.material.color.r = 1;
          // child.material.color.g = 0.1;
          // child.material.color.b = 0.1;
  
  
          this.prevObj = objNow;
          let tmpObj = {
            uuid:{},
            objMat:{}
          }
          tmpObj.uuid = child.uuid;
          tmpObj.objMat = child.material; 
          this.prevObjArr.push(tmpObj)
          child.material = new THREE.MeshBasicMaterial({color: '#006400'});   
        }
        //  && (child.name=="Model004")
        else if ((child.type== "Mesh") && (this.tower == 'CLARENDONCMTS')){
          // this.prevObj = child;
          // this.prevMaterial = child.material; 
          // child.material = new THREE.MeshBasicMaterial({color: 'red'});   
          // // console.log('child currematerial - ', child.material);
  
  
          this.prevObj = objNow;
          let tmpObj = {
            uuid:{},
            objMat:{}
          }
          tmpObj.uuid = child.uuid;
          tmpObj.objMat = child.material; 
          this.prevObjArr.push(tmpObj)
          child.material = new THREE.MeshBasicMaterial({color: '#006400'});   
        }
        else if ((child.type== "Mesh") && (this.tower == 'ALSTONVILLEEXCHANGE')){
          // this.prevObj = child;
          // this.prevMaterial = child.material; 
          // child.material = new THREE.MeshBasicMaterial({color: 'red'});   
          // // console.log('child currematerial - ', child.material);
  
  
          this.prevObj = objNow;
          let tmpObj = {
            uuid:{},
            objMat:{}
          }
          tmpObj.uuid = child.uuid;
          tmpObj.objMat = child.material; 
          this.prevObjArr.push(tmpObj)
          child.material = new THREE.MeshBasicMaterial({color: '#006400'});   
        }
        else if ((child.type== "Mesh") && (this.tower == 'ALTONAINDUSTRIAL')){
          this.prevObj = objNow;
          let tmpObj = {
            uuid:{},
            objMat:{}
          }
          tmpObj.uuid = child.uuid;
          tmpObj.objMat = child.material; 
          this.prevObjArr.push(tmpObj)
          child.material = new THREE.MeshBasicMaterial({color: '#006400'});   
          // console.log('child this.prevObjArr - ', this.prevObjArr);
        }
      });
      
      let bbbox = new THREE.Box3();
      bbbox
        .copy(this.box.geometry.boundingBox)
        .applyMatrix4(this.box.matrixWorld);
      let posNw = new THREE.Vector3(bbbox.max.x, bbbox.max.y, bbbox.max.z);
  
      this.changeCameraPositionWithRequestAnimationFrame(posNw.clone(), bbbox.max.x, bbbox.max.y, bbbox.max.z);
    }

  }

  toggleWaves(event, elt) {
    if (event.path[0].style.color == "grey") {
      event.path[0].removeAttribute("style")
      event.path[0].setAttribute("style", "color:#19b621");
    } else {
      event.path[0].removeAttribute("style")
      event.path[0].setAttribute("style", "color:grey");
    }
    this.waveVisibility(elt);
  }

  toggleAsset(event, elt) {
    let parent = event.target.parentElement;
    if (parent.children[0].style.display === "none") {
      parent.children[0].setAttribute("style", "display:block");
      event.path[0].setAttribute("style", "display:none");

    }
    if (parent.children[1].style.display === "none") {
      parent.children[1].setAttribute("style", "display:block");
      event.path[0].setAttribute("style", "display:none");

    }
    if(this.allLoaded == true){
    this.assetVisibility(elt);
    }
  }


  assetVisibility(elt) {
    let asset = this.scene.getObjectByName(elt);
    asset.visible = !asset.visible;

  }

  waveVisibility(elt) {
    let wave1 = this.scene.getObjectByName(elt + "_wave1");
    let wave2 = this.scene.getObjectByName(elt + "_wave2");
    wave1.visible = !wave1.visible;
    wave2.visible = !wave2.visible;

  }

  visibilitySlider(event) {
    console.log('this.pointsCloud - ', this.pointsCloud)
     
    this.pointsCloud.visible = true;
    this.sliderValue = event.value;

    if (this.sliderValue > 0) {
      this.pointsCloud.material.transparent = true;
      this.pointsCloud.material.opacity = 1 - this.sliderValue;
    } else if (this.sliderValue < 0) {
      this.telcoObjGrp.traverse((child) => { this.sliderCAD(child, this.sliderValue); });
    }
    if (this.sliderValue == 1) {
      this.pointsCloud.visible = false;
    }

  }

  sliderCAD(child, sliderValue) {
    if (child instanceof THREE.Mesh) {
      child.material.transparent = true;
      child.material.opacity = 1 + parseFloat(sliderValue);
    }
  }

  openModal(link) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = "100vh";
    dialogConfig.maxWidth = "100%";
    dialogConfig.width = "100%";
    dialogConfig.data = { link: link };
    this.dialog.open(ShelterModalComponent, dialogConfig).afterClosed().subscribe(() => { this.selectedShelter = null; });
  }

  clickEvent(event) {
    // let rect = this.container.domElement.getBoundingClientRect()
    // this.mouse.x = (event.clientX / this.container.nativeElement.offsetWidth) * 2 - 1;
    //  this.mouse.y = - (event.clientY / this.container.nativeElement.offsetHeight) * 2 + 1;
    // let rect = event.target.getBoundingClientRect();
    //   let dx = event.clientX - rect.x;
    //    let dy = event.clientY - rect.y;
    //     this.mouse.x = (dx / rect.width) * 2 - 1;
    //     this.mouse.y = (dy / rect.height) * 2 + 1;
    // console.log(this.mouse)
    //  this.mouse.x = (event.clientX / rect.width) * 2 - 1;
    //  this.mouse.y = - (event.clientY / rect.height) * 2 + 1;
    //  console.log(this.mouse)
    // this.raycaster.setFromCamera(this.mouse, this.camera);
    // let intersects = this.raycaster.intersectObjects(this.assets, true);
    // let intersected = intersects.length > 0 ? intersects[0] : null;
    // console.log(intersects[0])
    // if (intersected !== null) {
    //   for (let i = 0; i < this.auditData.Equipment.length; i++) {
    //     if (this.auditData.Equipment[i].Name == intersected.object.parent.name) {
    //       this.toggleEquipments(intersected.object.parent.name, i);
    //     }
    //   }

    // }
  }


  ngAfterViewInit() {


  }

  ngOnChanges() {
  }

  clearSelection(){
    if (this.box) {
      this.scene.remove(this.box);
    }


    // if((this.prevObj!= null) && ((this.tower == 'ESPERANCERT') || (this.tower == 'ALBANYEXCHANGE'))){
    //   this.prevObj.material.color.r = this.prevMatr;
    //   this.prevObj.material.color.g = this.prevMatg;
    //   this.prevObj.material.color.b = this.prevMatb;

    // }
    // else 
    if((this.prevObj!= null) && (this.tower != 'ESPERANCERT') && (this.tower != 'ALBANYEXCHANGE') && (this.tower != 'CLARENDONCMTS') && (this.tower != 'ALTONAINDUSTRIAL') && (this.tower != 'ALSTONVILLEEXCHANGE')){
      // this.prevObj.material.color.r = this.prevMatr;
      // this.prevObj.material.color.g = this.prevMatg;
      // this.prevObj.material.color.b = this.prevMatb;


    
      this.prevObj.traverse((child) => {
        if (child.type== "Mesh"){
          for (let index = 0; index < this.prevObjArr.length; index++) {
            if(this.prevObjArr[index].uuid == child.uuid){
              child.material =  this.prevObjArr[index].objMat;
            }
          }
        }
      })

    }
    else if ((this.prevObj!= null) &&(this.tower == 'CLARENDONCMTS')){
      // console.log(' this.prevMaterial - ', this.prevMaterial);
      
      // this.prevObj.material = this.prevMaterial;
      // this.prevObj.material.needsUpdate = true;
      // // console.log('this.prevObj - ', this.prevObj);
      // // console.log('this.scene - ', this.scene);
    
      this.prevObj.traverse((child) => {
        if (child.type== "Mesh"){
          for (let index = 0; index < this.prevObjArr.length; index++) {
            if(this.prevObjArr[index].uuid == child.uuid){
              child.material =  this.prevObjArr[index].objMat;
            }
          }
        }
      })
    }
    else if ((this.prevObj!= null) &&(this.tower == 'ALSTONVILLEEXCHANGE')){
      // this.prevObj.material = this.prevMaterial;
      // this.prevObj.material.needsUpdate = true;

      this.prevObj.traverse((child) => {
        if (child.type== "Mesh"){
          for (let index = 0; index < this.prevObjArr.length; index++) {
            if(this.prevObjArr[index].uuid == child.uuid){
              child.material =  this.prevObjArr[index].objMat;
            }
          }
        }
      })
    }
    else if ((this.prevObj!= null) && (this.tower == 'ALTONAINDUSTRIAL')){   
      // console.log('child this.prevObjArr - ', this.prevObjArr);

      this.prevObj.traverse((child) => {
        if (child.type== "Mesh"){
          for (let index = 0; index < this.prevObjArr.length; index++) {
            if(this.prevObjArr[index].uuid == child.uuid){
              child.material =  this.prevObjArr[index].objMat;
            }
          }
        }
      })
      
      

    }

  }

  onItemChange(value){
    console.log(" Value is : ", value );
    this.controllerMode = value;
  }

  zoomOutMouseDwn(event) {
    event.preventDefault();
    // this.controls.zoomOut();
    this.controls.dollyIn(this.controls.getZoomScale());
    this.controls.update();
  }

  zoomInMouseDwn(event) {
    event.preventDefault();
    // this.controls.zoomIn();
    this.controls.dollyOut(this.controls.getZoomScale());
    this.controls.update();
  }

  leftBtnClick(event){
    if(this.controllerMode == "Rotate"){
      // this.controls.rotateLeftFunc(this.rotExtraAngle);
      this.controls.rotateLeft(-this.controls.getAutoRotationAngle() - this.rotExtraAngle);
      this.controls.update();
    }else if(this.controllerMode == "Pan"){
      // this.controls.panLeftBut(this.panHoriDelta);
      this.controls.pan(-this.panHoriDelta, 0);
      this.controls.update();
    }
  }

  rightBtnClick(event){
    if(this.controllerMode == "Rotate"){
      // this.controls.rotateRightFunc(this.rotExtraAngle);
      this.controls.rotateLeft(this.controls.getAutoRotationAngle() + this.rotExtraAngle);
      this.controls.update()
    }else if(this.controllerMode == "Pan"){
      // this.controls.panRightBut(this.panHoriDelta);
      this.controls.pan(this.panHoriDelta, 0);
      this.controls.update();
    }
  }

  upBtnClick(event){
    if(this.controllerMode == "Rotate"){
      // this.controls.rotateUpFunc(this.rotExtraAngle);
      this.controls.rotateUp(-this.controls.getAutoRotationAngle() - this.rotExtraAngle);
      this.controls.update();
    }else if(this.controllerMode == "Pan"){
      this.scene.position.y = this.scene.position.y + 1;
    }
  }

  downBtnClick(event){
    if(this.controllerMode == "Rotate"){
      // this.controls.rotateDownFunc(this.rotExtraAngle);
      this.controls.rotateUp(this.controls.getAutoRotationAngle() + this.rotExtraAngle);
      this.controls.update();
    }else if(this.controllerMode == "Pan"){
      this.scene.position.y = this.scene.position.y - 1;
    }
  }

  recenterBtnClick(){
    // console.log('recenter');
    this.clearSelection();
    
    this.controls.target.set(0, 0, 0);
    this.controls.update();

    this.camera.position.x = this.cameraData.Position.x;
    this.camera.position.y = this.cameraData.Position.y;
    this.camera.position.z = this.cameraData.Position.z;
    this.camera.rotation.x = this.cameraData.Rotation.x;
    this.camera.rotation.y = this.cameraData.Rotation.y;
    this.camera.rotation.z = this.cameraData.Rotation.z;
  }

  contextLost(snackBar,glbLoaderPrg,animationID,renderer){
    return (event) => {
      event.preventDefault();
      glbLoaderPrg = ''
      snackBar.open('WEBGL Context Lost,Reload page', "close", { duration: 2000 });
      // animationID would have been set by your call to requestAnimationFrame
      window.cancelAnimationFrame(animationID);
      setTimeout(renderer.forceContextRestore, 100);
      // window.location.reload();
    }
  }

  main() {
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color('#272727');
    this.camera = new THREE.PerspectiveCamera(75, this.container.nativeElement.offsetWidth / this.container.nativeElement.offsetHeight, 0.1, 100000);

    this.renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
    });
    this.renderer.context.canvas.addEventListener("webglcontextlost", this.contextLost(this.snackBar,this.glbLoaderPrg,this.animationID,this.renderer), false);
    this.renderer.context.canvas.addEventListener("webglcontextrestored", function(event) {
      console.log("Webgl context restored")
      this.main()
    }, false);
    this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize(this.container.nativeElement.offsetWidth, this.container.nativeElement.offsetHeight);
    this.renderer.gammaOutput = true;
    this.container.nativeElement.appendChild(this.renderer.domElement);

    this.camera.position.x = this.cameraData.Position.x;
    this.camera.position.y = this.cameraData.Position.y;
    this.camera.position.z = this.cameraData.Position.z;
    this.camera.rotation.x = this.cameraData.Rotation.x;
    this.camera.rotation.y = this.cameraData.Rotation.y;
    this.camera.rotation.z = this.cameraData.Rotation.z;

    this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.controls.enableDamping = true;
    this.controls.dampingFactor = 0.25;
    this.controls.maxPolarAngle = Math.PI / 2;
    // this.controls.minDistance = 10;
    this.controls.zoomSpeed = 2.5;
    this.controls.rotateSpeed = 0.3;



    // var light = new THREE.DirectionalLight(0xffffff, 1);
    // light.position.set(4, 5, 4);
    // this.scene.add(light);

    // var light1 = new THREE.DirectionalLight(0xffffff, 1);
    // light1.position.set(-8, 6, 7);
    // this.scene.add(light1);

    // var light2 = new THREE.DirectionalLight(0xffffff, 1);
    // light2.position.set(2.1, -3.63, -1.27);
    // this.scene.add(light2);

    // var axesHelper = new THREE.AxesHelper( 500000);
    // this.scene.add( axesHelper );

    // New addition????
    this.controls.addEventListener( 'change', function(){      
      this.camera.getWorldDirection( this.cameraViewVector );
      this.compassAngleFromNorth = THREE.Math.radToDeg(this.cameraViewVector.angleTo( this.compassTarget ));
      if(this.cameraViewVector.x<0){
        this.compassAngleFromNorth = 360-this.compassAngleFromNorth;
      }
      this.compass_arrow.nativeElement.style.transform = `rotate(${this.compassAngleFromNorth}deg)`
  }.bind(this));

    var light = new THREE.DirectionalLight( 0xffffff, 1);  
    light.position.set( 4, 5, 4 );
    this.scene.add( light );
    
    var light1 = new THREE.DirectionalLight( 0xffffff,  1);  
    light1.position.set( -8, 6, 7);
    this.scene.add( light1 );

    var light2 = new THREE.DirectionalLight( 0xffffff,  1);  
    light2.position.set( 2.1, -3.63, -1.27 );
    this.scene.add( light2 );

    var light3 = new THREE.SpotLight( 0xffffff,  0.3 );  
    light3.position.set( 5, 10, -20 );
    this.scene.add( light3 );

      if(this.isLowValid){
        var gltfLoader_low = new GLTFLoader();
        gltfLoader_low.load(this.cadData["Link_low"], (gltf) => { 
          console.log("Low resolution loaded")
          this.glbLoaderPrg = "dn"
          this.addGLTF(gltf);
          this.loadHighGLB()
        },
        (xhr) => {
          this.abortLowScene = xhr
          this.percentageLoaded.prtLd = ((xhr.loaded / xhr.total) * 100).toFixed(2);
        }, 
        (e) => {
          if(e.type != 'abort'){
            this.glbLoaderPrg = "dn"
            this.container.nativeElement.setAttribute('style', 'display: none');
            this.Isdigi = false
            this.IsDigiError = "Data Loading error. Please check your internet connect & Reload"
          }
        });
      }
      else{
        this.loadHighGLB()
      }

    this.animate();

  }

  loadHighGLB(){
    if(this.isHighValid)
    {
      this.glbLoaderPrg = "dn"
      this.glbLoaderPrgHigh = ""
      var gltfLoader = new GLTFLoader();
      gltfLoader.load(this.cadData["Link"], (gltf) => { 
        console.log("High resolution loaded")
        this.renderer.renderLists.dispose()
        this.removeGLBFromScene()
        this.glbLoaderPrgHigh = "dn"
        this.addGLTF(gltf);
      },
      (xhr) => {
        this.abortHighScene = xhr
        this.percentageLoaded.prtLdHigh = ((xhr.loaded / xhr.total) * 100).toFixed(2);
      }, 
      (e) => {
        if(e.type != 'abort'){
          this.glbLoaderPrgHigh = "dn"
          this.container.nativeElement.setAttribute('style', 'display: none');
          this.Isdigi = false
          this.IsDigiError = "Data Loading error. Please check your internet connection & Reload"
        }
      });
    }
  }

  removeGLBFromScene(){
    if(this.scene != undefined){
      let index = 0
      while (index < this.scene.children.length)
      {
        let obj = this.scene.children[index]
        if(obj.type == "Group")
        {
          this.scene.remove( obj );
          this.disposeHierarchy(obj, this.disposeNode)
          index--
        }
        index++
      }
    }
  }

  disposeNode(node) {
    if (node instanceof THREE.Mesh) {
        node.parent = undefined;
        if (node.geometry) {
            node.geometry.dispose();
        }

        let material: any = node.material;
        if (material) {

            if (material.map) material.map.dispose();
            if (material.lightMap) material.lightMap.dispose();
            if (material.bumpMap) material.bumpMap.dispose();
            if (material.normalMap) material.normalMap.dispose();
            if (material.specularMap) material.specularMap.dispose();
            if (material.envMap) material.envMap.dispose();

            material.dispose();
        }
    } else if (node instanceof THREE.Object3D) {
        node.parent.remove(node);
        node.parent = undefined;
    }
}

  disposeHierarchy(node, callback) {
    for (var i = node.children.length - 1; i >= 0; i--) {
        var child = node.children[i];
        this.disposeHierarchy(child, callback);
        callback(child);
    }
  }

  compassInitialization(){    
    // this.camera.getWorldDirection( this.cameraViewVector );
    this.compassAngleFromNorth = THREE.Math.radToDeg(this.cameraViewVector.angleTo( this.compassTarget ));
    if(this.cameraViewVector.x<0){
      this.compassAngleFromNorth = 360-this.compassAngleFromNorth;
    }
    this.compass_arrow.nativeElement.style.transform = `rotate(${this.compassAngleFromNorth}deg)`
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.camera.aspect = this.container.nativeElement.offsetWidth / this.container.nativeElement.offsetHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(this.container.nativeElement.offsetWidth, this.container.nativeElement.offsetHeight);
  }

  @ViewChild('compass_arrow',{ static: false }) set content(content: ElementRef) {
    if(this.Link == null || this.Link == '' || this.Link == undefined) { // initially setter gets called with undefined
        this.compass_arrow = content;
        this.compassInitialization()
    }
 }


  addEquipments() {
    console.log(this.addEquipment)
    if (this.addEquipment === 'Antenna1') {
      this.addAsset('assets/models/equipment/antenna1.gltf');
    }
    if (this.addEquipment === 'Dish1') {
      this.addAsset('assets/models/equipment/dish1.gltf');

    }
    if (this.addEquipment === 'Dish2') {
      this.addAsset('assets/models/equipment/dish2.gltf')
    }
  }


  RemoveGizmoFromScene() {
    if (this.transformControl != null) {
      this.transformControl.detach();
      this.transformControl.dispose();
      this.scene.remove(this.transformControl);
      this.transformControl = null;
      this.transformControl = this.transformControl;
    }
  }


  scale() {
    // console.log('scaleBut');
    this.transformControl.mode = "scale";
  }
  rotate() {
    // console.log('rotBut');
    this.transformControl.mode = "rotate";
  }
  translate() {
    // console.log('posBut');
    this.transformControl.mode = "translate";
  }

  transformOnDraggingChanged(event) {

    this.controls.enabled = !event.value;

    // console.log('obj pos - ', objNw.position.x, ',', objNw.position.y, ',', objNw.position.z);
    // console.log('obj rot - ', objNw.rotation.x, ',', objNw.rotation.y, ',', objNw.rotation.z);
    // console.log('obj scale - ', objNw.scale.x, ',', objNw.scale.y, ',', objNw.scale.z);
  }

  transformControlOnObj() {

    this.transformControl = new TransformControls(this.camera, this.renderer.domElement);
    // transformControl.addEventListener('change', render);

    this.transformControl.addEventListener('dragging-changed', this.transformOnDraggingChanged.bind(this));
    // this.control.addEventListener( 'dragging-changed', ( event ) => this.orbit.enabled = ! event.value);

    this.transformControl.attach(this.sphere);
    this.scene.add(this.transformControl);
    // this.transformControl = transformControl;
  }

  loadGLTF(gltf) {
    this.RemoveGizmoFromScene();
    this.sphere = gltf.scene.children[0];
    this.scene.add(this.sphere);
    if (this.addEquipment === 'Antenna1') {
      this.sphere.scale.set(1.8, 1.8, 1.8)
    } else {
      this.sphere.scale.set(0.8, 0.8, 0.8)
    }

  }


  removeControls(){
    this.RemoveGizmoFromScene();
    if (this.abc != null) {
      this.scene.remove(this.abc);
      this.objects = [];
    }
  }

  dragSt() {
    this.RemoveGizmoFromScene();
    this.controls.enabled = false;

  }
  dragEd() {

    this.controls.enabled = true;
    this.transformControlOnObj();
  }

  dragging() {
    let pointFrom = this.abc.position;
    let target = new THREE.Vector3();
    let distMin = 1000000000;

    for (let index = 0; index < this.linePts.length; index++) {
      let lineNw = new THREE.Line3(new THREE.Vector3(this.linePts[index].x1, this.linePts[index].y1, this.linePts[index].z1), new THREE.Vector3(this.linePts[index].x2, this.linePts[index].y2, this.linePts[index].z2));

      let targetTmp = new THREE.Vector3();
      lineNw.closestPointToPoint(pointFrom, true, targetTmp)

      // console.log('targetTmp - ', targetTmp);

      let lineNw2 = new THREE.Line3(pointFrom, targetTmp);
      let distNw = lineNw2.distance();
      // console.log('distNw - ', distNw);

      if (distNw < distMin) {
        target = targetTmp.clone();
        distMin = distNw;
      }
    }

    // console.log('target - ', target);
    this.sphere.position.set(target.x, target.y, target.z);

    if (this.addEquipment === 'Antenna1') {
      if (target.x > 0 && (Math.abs(target.x) > Math.abs(target.z))) {
        // console.log('HERE00');
        this.sphere.rotation.y = -Math.PI / 2
        this.sphere.rotation.x = 0
        this.sphere.rotation.z = 0
      }
      else if (target.x < 0 && (Math.abs(target.x) > Math.abs(target.z))) {
        // console.log('HERE02');
        this.sphere.rotation.y = Math.PI / 2 + 0.785;
        this.sphere.rotation.x = 0
        this.sphere.rotation.z = 0
      }
      else if (target.z > 0 && (Math.abs(target.z) > Math.abs(target.x))) {
        // console.log('HERE03');
        this.sphere.rotation.y = Math.PI + 0.785;
        this.sphere.rotation.x = 0
        this.sphere.rotation.z = 0
      }
      else if (target.z < 0 && (Math.abs(target.z) > Math.abs(target.x))) {
        // console.log('HERE04');
        this.sphere.rotation.y = 0 - 0.785;
        this.sphere.rotation.x = 0
        this.sphere.rotation.z = 0
      }
    }
    else {
      if (target.x > 0 && (Math.abs(target.x) > Math.abs(target.z))) {
        // console.log('HERE');
        this.sphere.rotation.y = 0
        this.sphere.rotation.x = Math.PI / 2
        this.sphere.rotation.z = Math.PI / 2
      }
      else if (target.x < 0 && (Math.abs(target.x) > Math.abs(target.z))) {
        // console.log('HERE2');
        this.sphere.rotation.y = 0
        this.sphere.rotation.x = Math.PI / 2
        this.sphere.rotation.z = -Math.PI / 2
      }
      else if (target.z > 0 && (Math.abs(target.z) > Math.abs(target.x))) {
        // console.log('HERE3');
        this.sphere.rotation.y = 0
        this.sphere.rotation.x = -Math.PI / 2
        this.sphere.rotation.z = 0
      }
      else if (target.z < 0 && (Math.abs(target.z) > Math.abs(target.x))) {
        // console.log('HERE4');
        this.sphere.rotation.y = 0
        this.sphere.rotation.x = Math.PI / 2
        this.sphere.rotation.z = 0
      }
      // this.sphere.lookAt( new THREE.Vector3(abc.position.x, abc.position.y, abc.position.z))
      // abc.lookAt( new THREE.Vector3(sphere.position.x, this.sphere.position.y, this.sphere.position.z))
      // console.log('dragging - ', parseFloat(abc.position.x));
      // positionAndAlign2(sphere,  new THREE.Vector3(parseFloat(target.x), parseFloat(target.y), parseFloat(target.z)),  new THREE.Vector3(parseFloat(abc.position.x), parseFloat(abc.position.y), parseFloat(abc.position.z)))
    }
  }
  addAsset(assetLoc) {



    var loader = new GLTFLoader();
    if (this.abc != null) {
      this.scene.remove(this.abc);
      this.objects = [];
    }

    var geometry = new THREE.BoxBufferGeometry(2, 2, 2);
    var material = new THREE.MeshStandardMaterial({ color: 0xff00ff });
    this.abc = new THREE.Mesh(geometry, material);
    this.scene.add(this.abc);
    this.abc = this.abc;
    this.abc.position.set(0, 25, 10);
    this.objects.push(this.abc);


    loader.load(assetLoc, this.loadGLTF.bind(this));

    // this.dragControls = new DragControls(this.objects, this.camera, this.renderer.domElement);
    // this.dragControls.addEventListener('dragstart', this.dragSt.bind(this));
    // this.dragControls.addEventListener('dragend', this.dragEd.bind(this));
    // this.dragControls.addEventListener('drag', this.dragging.bind(this));

  }


  addGLTF(gltf) {
    this.telcoObjGrp = gltf.scene;
    this.scene.add(this.telcoObjGrp);

    // this.scene.traverse((child) => { this.sliderCAD(child, this.sliderValue); });
    this.pointsCloud = this.scene.getObjectByName("pcdMesh");
    console.log('this.scene - ', this.scene);
    // console.log('this.scene - ', this.scene.getObjectByName("mesh_764"));
    console.log(this.pointsCloud);
    this.allLoaded = true;
    


  }

  materialRenderOrder(elt, order) {
    elt.material.renderOrder = order;
    elt.material.transparent = true;
    elt.material.opacity = 0.5;
    elt.visible = false;
    elt.material.depthWrite = false;
  }


  changeCameraPositionWithRequestAnimationFrame(finalPos, maxX, maxY, maxZ) {
    this.stepsAbc = 0;
    if (Math.abs(maxX) > Math.abs(maxZ)) {
      if (Math.sign(maxX) === 1) {
        this.initialPosAbc = new THREE.Vector3(this.cameraData.Position.x, this.cameraData.Position.y, this.cameraData.Position.z);

      } else {
        this.initialPosAbc = new THREE.Vector3(-this.cameraData.Position.x, this.cameraData.Position.y, this.cameraData.Position.z);
      }
    }
    if (Math.abs(maxZ) > Math.abs(maxX)) {
      if (Math.sign(maxZ) === 1) {
        this.initialPosAbc = new THREE.Vector3(this.cameraData.Position.x, this.cameraData.Position.y, this.cameraData.Position.z);
      } else {
        this.initialPosAbc = new THREE.Vector3(this.cameraData.Position.x, this.cameraData.Position.y, - this.cameraData.Position.z);
      }
    }
    this.finalPosAbc = finalPos;

    this.lookAtObjAbc = finalPos;
    this.reqAnimGlobalId = requestAnimationFrame(() => { this.repeatOften() })
  }

  repeatOften() {
    this.stepsAbc += 0.02;

    this.newPositionAbc = new THREE.Vector3(0, 0, 0);
    this.newPositionAbc.lerpVectors(this.initialPosAbc, this.finalPosAbc, this.stepsAbc);
    this.camera.position.set(
      this.newPositionAbc.x,
      this.newPositionAbc.y,
      this.newPositionAbc.z
    );

    this.controls.target = this.lookAtObjAbc;
    this.controls.update();

    if (this.stepsAbc > 0.8) {
      cancelAnimationFrame(this.reqAnimGlobalId);
    } else {
      requestAnimationFrame(() => { this.repeatOften() });
    }

  }

  closeBox() {
    this.isOpen = false;
  }

  left() {
    this.camera.position.x -= 1;
  }

  right() {
    this.camera.position.x += 1;
  }

  down() {
    this.camera.position.y -= 1;
  }

  up() {
    this.camera.position.y += 1;

  }

  setImage(index) {
    this.crntImg = 0;
    this.detailImageIndex = index;
  }


  editData(key, value, section, detailIndex, sectionIndex, bool, sectionName = null) {
    if (sectionName != null) {
      for (let i = 0; i < this.auditData['Equipment'].length; i++) {
        if (this.auditData['Equipment'][i].Name === sectionName) {
          sectionIndex = i;
        }
      }
    }
    const dialogRef = this.dialog.open(EditComponent, {
      width: '450px',
      maxHeight: '850px',
      data: { value: value, name: key, leg: (section == "Equipment" && key == "Value" && detailIndex == 1) ? true : false }
    });
    dialogRef.afterClosed().subscribe(
      result => {
        if (result == undefined) { this.imageUpdateArray = undefined; this.updatedValue = undefined; return; }
        if (typeof (result.value) == 'object') {
          this.imageUpdateArray = result.value;
          this.updatedValue = '';
          this.updatedOption = 1;
        }
        if (typeof (result.value) == 'string') {
          if (result.value == undefined) {
            this.updatedValue = '';
          } else {
            this.updatedValue = result.value;
          }
          if (result.option == null || result.option == undefined) {
            this.updatedOption = 1
          }
          else {
            this.updatedOption = result.option;
          }
        }


      },
      (err) => {
        this.snackBar.open(err, "close", { duration: 2000 });
      },
      () => {
        if (this.imageUpdateArray == undefined && this.updatedValue == undefined) { return; }
        if (bool == true) {
          if (this.auditData[section][sectionIndex].Name != this.updatedValue) {
            this.auditData[section][sectionIndex].Name = this.updatedValue;
            this.updateData();
          }
        }
        else if (this.imageUpdateArray != undefined && this.imageUpdateArray.length) {
          this.imageUpdateArray = this.imageUpdateArray.filter(elt => {
            return (elt == "" || elt == null) ? false : true;
          })
          this.auditData[section][sectionIndex].Details[detailIndex][key] = this.imageUpdateArray;
          this.updateData();
        }
        else if (this.updatedValue != '' || this.updatedValue != undefined) {
          if (section == 'Equipment' && detailIndex == 0 && key == 'Value') {
            this.auditData[section][sectionIndex].Name = this.updatedValue;
            // this.updateAlias(value,this.updatedValue);
          }
          if (section == 'Equipment' && detailIndex == 1 && key == 'Value') {
            this.auditData[section][sectionIndex].Leg = this.updatedValue;
          }
          if (key === 'Value' && this.updatedOption !== undefined) {
            this.auditData[section][sectionIndex].Details[detailIndex]['Option'] = this.updatedOption;

          }
          if (this.auditData[section][sectionIndex].Details[detailIndex][key] != this.updatedValue) {
            this.auditData[section][sectionIndex].Details[detailIndex][key] = this.updatedValue;
          }

          this.updateData();
        }
        this.imageUpdateArray = [];
        this.updatedValue = '';
        this.updatedOption = undefined;
      }
    )


  }

  updateData() {
    this.service.setData(this.tower, this.siteId, this.year).update({
      Audit: this.auditData
    }).catch(err => {
      this.snackBar.open(err, "close", { duration: 2000 });
    })

    let count = [0, 0, 0, 0];
    for (let i = 0; i < this.auditData['General'].length; i++) {
      let details = this.auditData['General'][i]['Details'];
      for (let j = 0; j < details.length; j++) {
        if (details[j].Option === 1 && details[j].Value != "" && details[j].Value != null) count[0]++;
        if (details[j].Option === 2 && details[j].Value != "" && details[j].Value != null) count[1]++;
        if (details[j].Option === 3 && details[j].Value != "" && details[j].Value != null) count[2]++;
        if (details[j].Option === 4 && details[j].Value != "" && details[j].Value != null) count[3]++;
      }
    }
    for (let i = 0; i < this.auditData['Equipment'].length; i++) {
      for (let j = 0; j < this.auditData['Equipment'][i]['Details'].length; j++) {
        let details = this.auditData['Equipment'][i]['Details'];
        if (details[j].Option === 1 && details[j].Value != "" && details[j].Value != null) count[0]++;
        if (details[j].Option === 2 && details[j].Value != "" && details[j].Value != null) count[1]++;
        if (details[j].Option === 3 && details[j].Value != "" && details[j].Value != null) count[2]++;
        if (details[j].Option === 4 && details[j].Value != "" && details[j].Value != null) count[3]++;
      }
    }
    this.service.towersData(this.year).get().subscribe(
      (result) => {
        this.towers = result.data()['Towers']
      },
      (err) => {
        this.snackBar.open(err, "close", { duration: 2000 });
      },
      () => {
        this.towers.forEach((elt) => {
          if (elt.Tower.replaceAll(" ", "") == this.tower) {
            elt.Monitor = count[0];
            elt.Planned = count[1];
            elt.Urgent = count[2];
            elt.Emergency = count[3];

          }
        })
        this.service.towersData(this.year).update({
          Towers: this.towers
        }).catch(err => {
          this.snackBar.open(err, "close", { duration: 2000 });
        })
      }
    );

  }


  loadMsg() {
    setTimeout(() => { this.loaded = true; }, 2000);
  }

}
